
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Toast } from "vant";
import { EmployerActivityService } from "src/services";
import TypeOne from "./type/one.vue";
import TypeTwo from "./type/two.vue";
import TypeThree from "./type/three.vue";

@Component({
    components: {
        TypeOne,
        TypeTwo,
        TypeThree
    }
})
export default class CouponPage extends Vue
{
    // 用于刷新子组件
    private keyNum: any = 0;

    // 样式
    private pageStyle: any = {};

    // 优惠券数据
    private couponList: any = [];

    /**
     * 父组件传值
     * @private
     * @returns object
     */
    @Prop({type: Object, default: {}})
    private data: {};

    @Prop({type: String, default: ''})
    private bgColor: '';
    
    /**
     * 获取机构信息
     * @private
     * @returns void
     */
     private async getCouponListPage(): Promise<void>
    {
        try
        {
            let ids = (this.data as any).properties.dataModel.map(item => item.id) || [];
            // 仅获取未开始或进行中状态的优惠券
            let isOnlyValid = true;

            let {content: result} =  await EmployerActivityService.instance.getCouponListPage({ids, isOnlyValid});

            this.couponList = result.data || [];
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 组件创建钩子
     */
    protected created() {
        this.getCouponListPage();
    }

    /**
     * 值发生变化
     * @protected
     * @returns void
     */
    @Watch("data", {immediate: true, deep: true})
    private onDataChange(newValue: any): void
    {
        // 背景样式
        this.pageStyle = {'margin': newValue.properties.moduleSettings.upAndDown + 'px 0 0 0'}
        this.keyNum++;
    }
}

